// @ts-ignore
import * as typeformEmbed from '@typeform/embed';
import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

interface Props {
    id: string;
    currentId: string;
    url: string;
    onClose: () => void;
}

export const Typeform: React.FunctionComponent<Props> = ({
    id,
    currentId,
    url,
    onClose
}) => 
{
    const isVisible = id === currentId;
    const typeformRef = useRef(null);

    useEffect(() => 
    {
        // @ts-ignore
        typeformEmbed.makeWidget(typeformRef.current, url, {
            hideFooter: true,
            hideHeaders: true,
            opacity: 100,
        });
    }, [ typeformRef, url ]);

    return (
        <TypeformOverlay isVisible={isVisible}>
            <ExitButton src={exitButton} onClick={onClose} />
            <TypeformWidget isVisible={isVisible} ref={typeformRef} style={{
                height: 'calc(100vh - 80px)',
                width: 'calc(100% - 80px)',
                paddingTop: '40px',
                marginLeft: '40px'
            }} />
        </TypeformOverlay>
    );
};

const TypeformWidget = styled.div<{ isVisible: boolean; }>`
    ${props => 
    {
        return props.isVisible
            ? `
                opacity: 1;
                pointer-events: auto;
            `
            : `
                opacity: 0;
                pointer-events: none;
        `;
    }}

    transition: opacity 300ms ease 0.3s, visibility 0s linear 0s;
`;

const TypeformOverlay = styled.div<{ isVisible: boolean; }>`
    position: fixed;
    background-color: rgba(0,0,0,0.85);
    height: 100vh; 
    width: 100%;
    z-index: 1000000000000;
    ${props => 
    {
        return props.isVisible
            ? `
            opacity: 1;
            pointer-events: auto;
        `
            : `
            opacity: 0;
            pointer-events: none;
        `;
    }}
    transition: opacity 200ms ease 0s, visibility 0s linear 0s;

    @media only screen and (max-width: 600px) {
        // margin-top: -95px;
    }
`;

const ExitButton = styled.img`
    padding: 8px;
    cursor: pointer;
    right:0;
    margin-right: 6px;
    margin-top: 6px;
    position: absolute;
`;

const exitButton = 'data:image/gif;base64,R0lGODlhEQARAIAAAODn7P///yH5BAEHAAEALAAAAAARABEAAAIqBIKpab3v3EMyVHWtWZluf0za0XFNKDJfCq5i5JpomdUxqKLQVmInqyoAADs=';